import { useEffect, useState } from "react"
import { ChangeType } from "../../../api/EventTypes"
import { CommonErrorText } from "../../../common/errorText"
import { InputBlurEvent } from "../../../common/eventTypes"
import Input from "./Input"
import { IBaseFieldProperties } from "./interfaces"

interface INumberFieldProperties extends IBaseFieldProperties {
  value?: number | string
  maxLength?: number
  isEmpty?: boolean
}

const NumberField = (props: INumberFieldProperties) => {
  const { required } = props

  const [error, setError] = useState(false)
  const [tooltip, setTooltip] = useState(false)
  const [val, setVal] = useState("")

  useEffect(() => {
    const validated =
      props.validator &&
      props.validator.test(props.value && props.value.toString())

    if (validated === false && props.required && props.touched) {
      setError(true)
      setTooltip(true)
    }

    const hasError = props.touched && !props.isEmpty && validated === false

    if (hasError) {
      setError(true)
      setTooltip(true)
    }
  }, [
    props.isEmpty,
    props.name,
    props.required,
    props.touched,
    props.validator,
    props.value,
    val
  ])

  const handleValueChange = (e: ChangeType) => {
    const { name, value } = e.target
    const empty = value === null || value === ""
    setTooltip(false)
    const val = value !== "" ? Number(value) : null

    const validated = props.validator && props.validator.test(value)
    const errors =
      (validated === false && value !== "") || (required && value === "")

    if (!empty) {
      if (validated) {
        setError(false)
      }
    }
    if (empty && !required) {
      setError(false)
    }
    if (validated === undefined) {
      setError(false)
    }

    if (!validated) {
      setError(true)

      if (value !== "" && validated !== undefined) {
        setError(true)
      }
    }
    setVal(value)
    props.onChange(name, val, errors)
  }

  const handleBlur = (e: InputBlurEvent) => {
    const { value } = e.target
    const validated = props.validator && props.validator.test(value)

    if (value !== "") {
      if (validated === false) {
        setError(true)
        setTooltip(true)
      }
    }

    if (validated === undefined) {
      setError(false)
    }

    if (validated === false && props.required) {
      setError(true)
      setTooltip(true)
    }
  }

  const showTooltip = error && tooltip
  const errorText =
    val === null || val === ""
      ? CommonErrorText.noEmptyValue
      : props?.validationError
  return (
    <Input
      name={props.name}
      inputIdentifier={props.name}
      label={props.caption}
      type="number"
      value={props.value}
      onChange={handleValueChange}
      onBlur={handleBlur}
      maxLength={props.maxLength}
      readonly={props.readonly}
      showTooltip={showTooltip}
      hideErrorMsg
      onInput={(e) => {
        let inputTarget = e.target
        if (inputTarget.value.length > props.maxLength) {
          inputTarget.value = inputTarget.value.slice(0, props.maxLength)
        }
      }}
      hasChanges={props.hasChanges}
      absoluteOptional={props.absoluteOptional}
      error={errorText}
      onKeyPress={(e) => {
        if (/\D/.test(e.key)) {
          e.preventDefault()
        }
      }}
    />
  )
}

export default NumberField

